import { Navigate, useLocation } from "react-router-dom";
import { useAuthContext } from "context/auth-context";

const PublicRoute = ({ children }) => {
    const location = useLocation();
    const { authenticated, loading } = useAuthContext();

    if (loading) return <div>Loading...</div>;

    return authenticated && location.pathname !== '/callback' ? <Navigate to="/dashboard" replace /> : children;
};

export default PublicRoute;
